/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react';
import clsx from 'clsx';
import {useMediaQuery} from '@mantine/hooks';

import {useDispatch, useSelector} from '~/store/hooks';
import Icon, {Icons} from '~/common/Icon';
import {WebsiteThemes} from '~/utils/constants';
import {isMobileDevice} from '~/utils/browserDetect';
import useWindowLandscape from '~/hooks/useWindowLandscape';
import {Modals} from '~/modals/constants';

import s from './styles.module.scss';

const GuestMenu: FC<{isSnackbarVisible?: boolean}> = ({isSnackbarVisible}) => {
  const dispatch = useDispatch();
  const data = useSelector((store) => store.app.data);
  const isMobile = useMediaQuery('(max-width: 767px)');
  const isLandscape = useWindowLandscape();

  // Hack!!!
  const handleClose = () => {
    document.dispatchEvent(new Event('click'));
  };

  return (
    <div
      className={clsx(s.wrapper, {
        [s['wrapper--shifted']]: isSnackbarVisible,
        [s['wrapper--landscape']]: isLandscape && isMobileDevice(),
      })}
    >
      <div>
        <div className={s['icon-wrapper']}>
          <Icon name={Icons.cross} className={s['close-icon']} onClick={handleClose} />
        </div>
        <li className="teeny-menu-iconed__item" id="sign_in">
          <a href="/signin" className="teeny-menu-iconed__link">
            <div className="teeny-menu-iconed__icon-wrapper">
              <Icon
                name={Icons.guestSignInBold}
                className={clsx('teeny-menu-iconed__icon', 'teeny-menu-iconed__icon_signin_bold')}
              />
            </div>
            <div className={clsx('teeny-menu-iconed__title', s['menu-item'])}>Sign in</div>
          </a>
        </li>
        <li className="teeny-menu-iconed__item  " id="advertise">
          <a href="/advertiser-signup" className="teeny-menu-iconed__link">
            <div className="teeny-menu-iconed__icon-wrapper">
              <Icon
                name={Icons.guestAdvertise}
                className={clsx(
                  'teeny-menu-iconed__icon',
                  'teeny-menu-iconed__icon_advertise_bold'
                )}
              />
            </div>
            <div className={clsx('teeny-menu-iconed__title', s['menu-item'])}>Advertise</div>
          </a>
        </li>
      </div>
      <div style={{borderTop: '1px solid #D9D9D9'}}>
        <div className={clsx('teeny-menu-iconed__copyright', s['menu-item-copyright'])}>
          © {new Date().getFullYear()} {data.instanceInfo.label}
        </div>
      </div>
    </div>
  );
};

export default GuestMenu;
